// Vendor imports
const React = require('react')
const qs = require('qs')
// Shared imports
const BemEntity = require('shared/bem')
const { urlWithoutProtocol } = require('shared/utils')
// Client V2 common imports
const { CapsuleButton } = require('client-v2/common/components/buttons')
const UserAvatar = require('client-v2/common/components/user-avatar')
const useClientEffect = require('client-v2/common/hooks/client-effect')
const tag = require('client-v2/common/utils/hyperscript')
// Entry imports
const IntoHeader = require('client-v2/into-landing/containers/header/component-smart')
const IntoFooter = require('client-v2/into-landing/components/footer')
const IntoLinkModal = require('client-v2/into-landing/containers/link-modal/component-smart')
const TopicProfileFeed = require('./containers/feed/component-smart')

const bem = BemEntity('IntoTopicProfileLayout')

function IntoTopicProfileLayout(props) {
  const { baseUrl, iosDeeplinkHref, isAndroid, isDesktop, isIos, onFollowClick, emptyFeedItems, feedItems, topic } = props
  const remainingFollowerCount = topic.followerCount - 6
  const [ itemColumnCount, setItemColumnCount ] = React.useState(null)

  function onResize() {
    const el = document.body
    if (el.clientWidth <= 1000) {
      setItemColumnCount(2)
    } else if (el.clientWidth <= 1440) {
      setItemColumnCount(3)
    } else {
      setItemColumnCount(4)
    }
  }

  useClientEffect(
    () => {
      onResize()
      window.addEventListener('resize', onResize)
      return () => {
        window.removeEventListener('resize', onResize)
      }
    },
    []
  )

  const handleFollowClick = React.useCallback(
    event => {
      if (isAndroid) {
        return
      }
      event.preventDefault()
      const topicProfile = baseUrl + `/topic/${topic.slug}`
      const deeplinkData = {
        // Delivered as query parameter when handling the universal links.
        'deeplink_url': topicProfile,
        // Fallbacks to mix://$deeplink_path when universal links do not work.
        // Docs: https://docs.branch.io/pages/links/integrate/#deep-linking
        '$deeplink_path': urlWithoutProtocol(topicProfile)
      }
      const queryString = qs.stringify(deeplinkData)
      if (isIos) {
        location.assign(`${iosDeeplinkHref}?${queryString}`)
        return
      }
      if (isDesktop){
        onFollowClick({
          deeplinkData,
          isDownloadPromptVisible: true
        })
      }
    },
    [ baseUrl, iosDeeplinkHref, isAndroid, isDesktop, isIos, onFollowClick, topic ]
  )

  return (
    tag('div', {
      className: bem.block()
    },
      tag(IntoHeader, {
        className: bem.element('header')
      }),
      tag('div', {
        className: bem.element('body')
      },
        tag('div', {
          className: bem.element('text')
        },
          tag('div', {
            className: bem.element('details')
          },
            tag('div', {
              className: bem.element('headline')
            },
              tag('div', {
                className: bem.element('name')
              },
                topic.name
              ),
              tag(CapsuleButton, {
                className: bem.element('follow'),
                onClick: handleFollowClick
              },
                'Follow'
              )
            ),
            topic.followerCount > 0 && tag([
              tag('div', {
                className: bem.element('subheadline')
              },
                'Followed by'
              ),
              tag('div', {
                className: bem.element('followers')
              },
                topic.followers.map(user => (
                  tag(UserAvatar, {
                    className: bem.element('follower'),
                    badge: false,
                    href: true,
                    user
                  })
                )),
                remainingFollowerCount > 0 && tag(CapsuleButton, {
                  className: bem.element('load-more'),
                  onClick: handleFollowClick
                },
                  `+ ${remainingFollowerCount} `,
                  remainingFollowerCount === 1 ? 'other' : 'others'
                )
              )
            ]),
            topic.related.size > 0 && tag([
              tag('div', {
                className: bem.element('subheadline')
              },
                'Related topics'
              ),
              tag('div', {
                className: bem.element('related')
              },
                topic.related.map(item => (
                  tag('a', {
                    className: bem.element('related-item'),
                    href: `/topic/${item.slug}`
                  }, 
                    tag('span', {
                      className: bem.element('related-hashtag')
                    },
                      ' # '
                    ),
                    item.name
                  )
                ))
              )
            ])
          ),
          tag(IntoLinkModal, {
            className: bem.element('link-modal', 'large'),
            caption:
              tag('div', {
                className: bem.element('caption', 'small')
              },
                `Follow ${topic.name} and more on Mix`
              )
          })
        ),
        tag('div', {
          className: bem.element('feed')
        },
          tag(TopicProfileFeed, {
            className: bem.element('grid'),
            items: feedItems.slice(0, feedItems.size - (feedItems.size % itemColumnCount))
          }),
          tag('div', {
            className: bem.element('fade')
          },
            tag(TopicProfileFeed, {
              className: bem.element('grid'),
              items: emptyFeedItems
            }),
            tag('div', {
              className: bem.element('see-more')
            },
              tag('a', {
                className: bem.element('see-more-cta'),
                href: '/',
                onClick: handleFollowClick
              },
                'See more on the Mix app'
              )
            )
          )
        ),
        tag(IntoLinkModal, {
          className: bem.element('link-modal', 'small'),
          caption:
            tag('div', {
              className: bem.element('caption', 'small')
            },
              `Follow ${topic.name} and more on Mix`
            )
        })
      ),
      tag(IntoFooter, {
        className: bem.element('footer')
      })
    )
  )
}

module.exports = IntoTopicProfileLayout
